export const FETCH_MEMBERS_SUCCESS = "app/members/FETCH_MEMBERS_SUCCESS";
export const FETCH_MEMBERS_FAIL = "app/members/FETCH_MEMBERS_FAIL";

export const GET_MEMBER_PROFILE_SUCCESS = "app/members/GET_MEMBER_PROFILE_SUCCESS";
export const GET_MEMBER_PROFILE_FAIL = "app/members/GET_MEMBER_PROFILE_FAIL";